<template>
     <h5 v-if="percent >= 0">Sessions
        <ProgressBar :percent="percent" />
     </h5>
</template>
<script>
import ProgressBar from '@/components/ProgressBar';
export default {
    name: "ProgressBarAppointments",
    components: {
        ProgressBar,
    },
    computed: {
        percent() {
            return this.$store.state.appointments.loading;
        },
    }
}
</script>
<style>

</style>